/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ startDate: NonNullable<unknown>, startTime: NonNullable<unknown>, endDate: NonNullable<unknown> }} Campaigns_Mag7_Spacex_Fine_Print_DatesInputs */

const en_campaigns_mag7_spacex_fine_print_dates = /** @type {(inputs: Campaigns_Mag7_Spacex_Fine_Print_DatesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Rewards of 10% APR are paid on your balance from ${i?.startDate} at ${i?.startTime} through ${i?.endDate}.`)
};

const de_campaigns_mag7_spacex_fine_print_dates = /** @type {(inputs: Campaigns_Mag7_Spacex_Fine_Print_DatesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Prämien von 10 % APR werden vom ${i?.startDate} um ${i?.startTime} bis zum ${i?.endDate} auf Ihr Guthaben gezahlt.`)
};

const pt_br2_campaigns_mag7_spacex_fine_print_dates = /** @type {(inputs: Campaigns_Mag7_Spacex_Fine_Print_DatesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`As recompensas de 10% de APR são pagas sobre seu saldo de ${i?.startDate}, às ${i?.startTime}, até ${i?.endDate}.`)
};

const tr_campaigns_mag7_spacex_fine_print_dates = /** @type {(inputs: Campaigns_Mag7_Spacex_Fine_Print_DatesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`%10 APR ödülleri, ${i?.startDate} tarihinde saat ${i?.startTime} itibarıyla ${i?.endDate} tarihine kadar bakiyeniz üzerinden ödenir.`)
};

const zh_cn2_campaigns_mag7_spacex_fine_print_dates = /** @type {(inputs: Campaigns_Mag7_Spacex_Fine_Print_DatesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`10% 年化收益奖励按余额计算，发放期为 ${i?.startDate} ${i?.startTime} 起至 ${i?.endDate} 止。`)
};

const zh_hk2_campaigns_mag7_spacex_fine_print_dates = /** @type {(inputs: Campaigns_Mag7_Spacex_Fine_Print_DatesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`10% 年利率獎賞按你的結餘計算，由 ${i?.startDate} ${i?.startTime} 起至 ${i?.endDate} 止。`)
};

const ko_kr2_campaigns_mag7_spacex_fine_print_dates = /** @type {(inputs: Campaigns_Mag7_Spacex_Fine_Print_DatesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`연 10% APR 리워드는 ${i?.startDate} ${i?.startTime}부터 ${i?.endDate}까지 잔액에 대해 지급됩니다.`)
};

const ru_ru2_campaigns_mag7_spacex_fine_print_dates = /** @type {(inputs: Campaigns_Mag7_Spacex_Fine_Print_DatesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Вознаграждения в размере 10% годовых начисляются на баланс с ${i?.startDate} в ${i?.startTime} по ${i?.endDate}.`)
};

const es_419_campaigns_mag7_spacex_fine_print_dates = /** @type {(inputs: Campaigns_Mag7_Spacex_Fine_Print_DatesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Las recompensas de 10% APR se pagan sobre tu saldo desde el ${i?.startDate} a las ${i?.startTime} hasta el ${i?.endDate}.`)
};

/**
* | output |
* | --- |
* | "Rewards of 10% APR are paid on your balance from {startDate} at {startTime} through {endDate}." |
*
* @param {Campaigns_Mag7_Spacex_Fine_Print_DatesInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const campaigns_mag7_spacex_fine_print_dates = /** @type {((inputs: Campaigns_Mag7_Spacex_Fine_Print_DatesInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Campaigns_Mag7_Spacex_Fine_Print_DatesInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_campaigns_mag7_spacex_fine_print_dates(inputs)
	if (locale === "de") return de_campaigns_mag7_spacex_fine_print_dates(inputs)
	if (locale === "pt-BR") return pt_br2_campaigns_mag7_spacex_fine_print_dates(inputs)
	if (locale === "tr") return tr_campaigns_mag7_spacex_fine_print_dates(inputs)
	if (locale === "zh-CN") return zh_cn2_campaigns_mag7_spacex_fine_print_dates(inputs)
	if (locale === "zh-HK") return zh_hk2_campaigns_mag7_spacex_fine_print_dates(inputs)
	if (locale === "ko-KR") return ko_kr2_campaigns_mag7_spacex_fine_print_dates(inputs)
	if (locale === "ru-RU") return ru_ru2_campaigns_mag7_spacex_fine_print_dates(inputs)
	return es_419_campaigns_mag7_spacex_fine_print_dates(inputs)
});